import cs from 'classnames';
import { useState, forwardRef, useImperativeHandle, useRef } from 'react';
import { stylesOptions } from '@app/story/CreateStory/constants';
import styles from './index.module.scss';

// Import all style images
import cartoonSmall from '../../assets/images/StylesIconSmall/Cartoon_Small.png';
import retro1950sSmall from '../../assets/images/StylesIconSmall/Retro 1950s Children’s Book Illustration_Small.png';
import minecraftStyleSmall from '../../assets/images/StylesIconSmall/Minecraft Style_Small.png';
import threeDIllustrationSmall from '../../assets/images/StylesIconSmall/3D Illustration_Small.png';
import animeSmall from '../../assets/images/StylesIconSmall/Anime_Small.png';
import bookCoverIllustrationSmall from '../../assets/images/StylesIconSmall/Book Cover Illustration_Small.png';
import charmingStorybookSmall from '../../assets/images/StylesIconSmall/charming storybook illustration_Small.png';
import claymationStyleSmall from '../../assets/images/StylesIconSmall/Claymation Style_Small.png';
import coloringBookSmall from '../../assets/images/StylesIconSmall/Coloring Book_Small.png';
import comicBookSmall from '../../assets/images/StylesIconSmall/Comic Book_Small.png';
import fourPanelComicSmall from '../../assets/images/StylesIconSmall/Four-panel comic strip illustration_Small.png';
import handmadePaperSmall from '../../assets/images/StylesIconSmall/Handmade paper cut-out collage illustration_Small.png';
import isometricIllustrationSmall from '../../assets/images/StylesIconSmall/Isometric Illustration_Small.png';
import legoSmall from '../../assets/images/StylesIconSmall/Lego_Small.png';
import lowPolySmall from '../../assets/images/StylesIconSmall/Low Poly_Small.png';
import minimalistInkSmall from '../../assets/images/StylesIconSmall/Minimalist ink-style_Small.png';
import minimalisticIllustrationSmall from '../../assets/images/StylesIconSmall/Minimalistic Illustration_Small.png';
import pastelDrawingSmall from '../../assets/images/StylesIconSmall/Pastel Drawing Style_Small.png';
import photorealisticSmall from '../../assets/images/StylesIconSmall/Photorealistic_Small.png';
import pixarStyleSmall from '../../assets/images/StylesIconSmall/Pixar Style_Small.png';
import popArtStyleSmall from '../../assets/images/StylesIconSmall/Pop Art Style_Small.png';
import sketchStylesSmall from '../../assets/images/StylesIconSmall/Sketch Styles_Small.png';
import stencilStyleSmall from '../../assets/images/StylesIconSmall/Stencil-style street art mural_Small.png';
import stylizedDigitalSmall from '../../assets/images/StylesIconSmall/Stylized digital illustration_Small.png';
import vintageStyleSmall from '../../assets/images/StylesIconSmall/Vintage-style_Small.png';
import watercolorSmall from '../../assets/images/StylesIconSmall/Watercolor_Small.png';
import whimsicalIllustrationSmall from '../../assets/images/StylesIconSmall/Whimsical illustration_Small.png';

// Import all style images
import cartoonLarge from '../../assets/images/StylesIconLarge/Cartoon_Big.png';
import retro1950sLarge from '../../assets/images/StylesIconLarge/Retro 1950s Children’s Book Illustration_Big.png';
import minecraftStyleLarge from '../../assets/images/StylesIconLarge/Minecraft Style_Big.png';
import threeDIllustrationLarge from '../../assets/images/StylesIconLarge/3D Illustration_Big.png';
import animeLarge from '../../assets/images/StylesIconLarge/Anime_Big.png';
import bookCoverIllustrationLarge from '../../assets/images/StylesIconLarge/Book Cover Illustration_Big.png';
import charmingStorybookLarge from '../../assets/images/StylesIconLarge/charming storybook illustration_Big.png';
import claymationStyleLarge from '../../assets/images/StylesIconLarge/Claymation Style_Big.png';
import coloringBookLarge from '../../assets/images/StylesIconLarge/Coloring Book_Big.png';
import comicBookLarge from '../../assets/images/StylesIconLarge/Comic Book_Big.png';
import fourPanelComicLarge from '../../assets/images/StylesIconLarge/Four-panel comic strip illustration_Big.png';
import handmadePaperLarge from '../../assets/images/StylesIconLarge/Handmade paper cut-out collage illustration_Big.png';
import isometricIllustrationLarge from '../../assets/images/StylesIconLarge/Isometric Illustration_Big.png';
import legoLarge from '../../assets/images/StylesIconLarge/Lego_Big.png';
import lowPolyLarge from '../../assets/images/StylesIconLarge/Low Poly_Big.png';
import minimalistInkLarge from '../../assets/images/StylesIconLarge/Minimalist ink-style_Big.png';
import minimalisticIllustrationLarge from '../../assets/images/StylesIconLarge/Minimalistic Illustration_Big.png';
import pastelDrawingLarge from '../../assets/images/StylesIconLarge/Pastel Drawing Style_Big.png';
import photorealisticLarge from '../../assets/images/StylesIconLarge/Photorealistic_Big.png';
import pixarStyleLarge from '../../assets/images/StylesIconLarge/Pixar Style_Big.png';
import popArtStyleLarge from '../../assets/images/StylesIconLarge/Pop Art Style_Big.png';
import sketchStylesLarge from '../../assets/images/StylesIconLarge/Sketch Styles_Big.png';
import stencilStyleLarge from '../../assets/images/StylesIconLarge/Stencil-style street art mural_Big.png';
import stylizedDigitalLarge from '../../assets/images/StylesIconLarge/Stylized digital illustration_Big.png';
import vintageStyleLarge from '../../assets/images/StylesIconLarge/Vintage-style_Big.png';
import watercolorLarge from '../../assets/images/StylesIconLarge/Watercolor_Big.png';
import whimsicalIllustrationLarge from '../../assets/images/StylesIconLarge/Whimsical illustration_Big.png';

// Mapping object to match style values with their corresponding images
const styleImageMap: { [key: string]: string } = {
  '3D Illustration': threeDIllustrationSmall,
  Anime: animeSmall,
  'Book Cover Illustration': bookCoverIllustrationSmall,
  Cartoon: cartoonSmall,
  'Charming Storybook Illustration': charmingStorybookSmall,
  'Claymation Style': claymationStyleSmall,
  'Coloring Book': coloringBookSmall,
  'Comic Book': comicBookSmall,
  'Four-panel Comic Strip Illustration': fourPanelComicSmall,
  'Handmade Paper Cut-out Collage Illustration': handmadePaperSmall,
  'Isometric Illustration': isometricIllustrationSmall,
  Lego: legoSmall,
  'Low Poly': lowPolySmall,
  'Minimalist Ink-style': minimalistInkSmall,
  'Minimalistic Illustration': minimalisticIllustrationSmall,
  'Minecraft Style': minecraftStyleSmall,
  'Pastel Drawing Style': pastelDrawingSmall,
  Photorealistic: photorealisticSmall,
  'Pixar Style': pixarStyleSmall,
  'Pop Art Style': popArtStyleSmall,
  "Retro 1950s Children's Book Illustration": retro1950sSmall,
  'Sketch Styles': sketchStylesSmall,
  'Stencil-style Street Art Mural': stencilStyleSmall,
  'Stylized Digital Illustration': stylizedDigitalSmall,
  'Vintage-style': vintageStyleSmall,
  Watercolor: watercolorSmall,
  'Whimsical Illustration': whimsicalIllustrationSmall,
};

const styleLargeImageMap: { [key: string]: string } = {
  '3D Illustration': threeDIllustrationLarge,
  Anime: animeLarge,
  'Book Cover Illustration': bookCoverIllustrationLarge,
  Cartoon: cartoonLarge,
  'Charming Storybook Illustration': charmingStorybookLarge,
  'Claymation Style': claymationStyleLarge,
  'Coloring Book': coloringBookLarge,
  'Comic Book': comicBookLarge,
  'Four-panel Comic Strip Illustration': fourPanelComicLarge,
  'Handmade Paper Cut-out Collage Illustration': handmadePaperLarge,
  'Isometric Illustration': isometricIllustrationLarge,
  Lego: legoLarge,
  'Low Poly': lowPolyLarge,
  'Minimalist Ink-style': minimalistInkLarge,
  'Minimalistic Illustration': minimalisticIllustrationLarge,
  'Minecraft Style': minecraftStyleLarge,
  'Pastel Drawing Style': pastelDrawingLarge,
  Photorealistic: photorealisticLarge,
  'Pixar Style': pixarStyleLarge,
  'Pop Art Style': popArtStyleLarge,
  "Retro 1950s Children's Book Illustration": retro1950sLarge,
  'Sketch Styles': sketchStylesLarge,
  'Stencil-style Street Art Mural': stencilStyleLarge,
  'Stylized Digital Illustration': stylizedDigitalLarge,
  'Vintage-style': vintageStyleLarge,
  Watercolor: watercolorLarge,
  'Whimsical Illustration': whimsicalIllustrationLarge,
};

interface IStyleCard {
  selectedStyle: string;
  setSelectedStyle: (val: string) => void;
  onSwiperInit?: (swiper: any) => void;
}

const StyleCard = forwardRef<any, IStyleCard>(
  ({ selectedStyle, setSelectedStyle, onSwiperInit }, ref) => {
    const [hoveredStyle, setHoveredStyle] = useState<string | null>(null);
    const swiperRef = useRef<any>(null);

    // Swiper imports
    // @ts-ignore
    // eslint-disable-next-line
    const { Swiper, SwiperSlide } = require('swiper/react');
    require('swiper/css');

    useImperativeHandle(ref, () => ({
      slideNext: () => swiperRef.current?.slideNext(),
      slidePrev: () => swiperRef.current?.slidePrev(),
      slideTo: (idx: number) => swiperRef.current?.slideTo(idx),
    }));

    return (
      <div className={styles['card']}>
        <Swiper
          spaceBetween={24}
          slidesPerView={'auto'}
          onSwiper={(swiper: any) => {
            swiperRef.current = swiper;
            if (onSwiperInit) onSwiperInit(swiper);
          }}>
          {stylesOptions.map((item, index) => {
            const imageSrc = styleImageMap[item.value];
            const largeImageSrc = styleLargeImageMap[item.value];
            return (
              <SwiperSlide key={index} style={{ width: '167px' }}>
                <div
                  className={cs([
                    styles['style_card'],
                    item.value === selectedStyle ? styles['active'] : '',
                  ])}
                  onClick={() => setSelectedStyle(item.value as string)}
                  onMouseEnter={() => setHoveredStyle(item.value as string)}
                  onMouseLeave={() => setHoveredStyle(null)}>
                  <div className={styles.image_container}>
                    <img src={imageSrc} alt={`${item.label} Style`} />
                  </div>
                  <p className={styles['title']}>{item.label}</p>
                  {hoveredStyle === item.value && (
                    <div className={styles['modal']}>
                      <img
                        src={largeImageSrc}
                        alt={`${item.label} Large Style`}
                      />
                    </div>
                  )}
                </div>
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
    );
  },
);

export default StyleCard;
